(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            //	factory: checkRoute,
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
    
   // checkRoute.$inject = ['$q', '$rootScope', '$location'];    
    //function checkRoute($q, $rootScope, $location) {
        /*
    	if ($rootScope.userProfile) {
            return true;
        } else {
            var deferred = $q.defer();
            $http.post("/loadUserProfile", { userToken: "blah" })
                .success(function (response) {
                    $rootScope.userProfile = response.userProfile;
                    deferred.resolve(true);
                })
                .error(function () {
                    deferred.reject();
                    $location.path("/");
                 });
            return deferred.promise;
        }
        */
    //	console.log("route check called");
    //	return true;
    //};
    
})();
